const traitserverUrl = 'https://land.impostors.superaws.net';
const config = {
  traitserverUrl
};
export default config;
